module.exports = __webpack_public_path__ + "static/media/outplay-logo.6e3c824b.svg";